export default __webpack_public_path__ + "static/media/grey6-top.0b177ba0.svg";